import axiosInstance from '../utils/axios';

// Получить остатки товаров
export const getInventory = async () => {
  try {
    const response = await axiosInstance.get('/inventory');
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Получить прайслист
export const getPriceList = async () => {
  try {
    const response = await axiosInstance.get('/inventory/pricelist');
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
